import { Inject, Injectable, InjectionToken } from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { Router } from '@angular/router'
import { UsuarioService } from '../service/index.service'
import { UturuncoUtils } from '../utils/uturuncoUtils'

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(private router: Router, private wsdl: UsuarioService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const headers = UturuncoUtils.getHeader()

    const reqClone = req.clone({
      headers,
    })
    if (req.url.includes('') || req.url.includes('dolarapi.com/v1') || req.url.includes('api/usuario/refresh/user')) {
      return next.handle(req)
    } else {
      return next.handle(reqClone).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.body.code == 200) {

              const refres = UturuncoUtils.getSession(UturuncoUtils.RF)

              if (refres) {
                const token = UturuncoUtils.getToken()

                let expirado = true
                let payload

                if (token != undefined || token != null) {
                  var encodedStr = atob(token.split('.')[1])
                  payload = JSON.parse(encodedStr)
                  expirado = UturuncoUtils.expirado(payload.exp)
                } else {
                  payload = { exp: 1589670086 }
                }

                this.verificaRenueva(payload.exp)

              } else {
                this.router.navigate(['login'])
                // return false;
              }
            }
            if (event.body.code == 401) {
              UturuncoUtils.clearSession()
              this.router.navigate(['login'])
            }
          }

          return event
        }),
        catchError(this.manejarError),
      )
    }


  }

  manejarError(error: HttpErrorResponse) {
    console.error('Sucedió un error')
    console.error('Registrado en el log file')
    console.warn(error)
    return throwError('Error personalizado')
  }

  verificaRenueva(fechaExp: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let tokenExp = new Date(fechaExp * 1000)
      let ahora = new Date()
      ahora.setTime(ahora.getTime() + 15 * 60 * 1000)
      if (tokenExp.getTime() > ahora.getTime()) {
        resolve(true)
      } else {
        this.wsdl.doRefresh().then(
          (res: any) => {
            if (res.code == 200) {
              UturuncoUtils.setToken(res.token)
              resolve(true)
            } else {
              UturuncoUtils.clearSession()
              this.router.navigate(['login'])
              resolve(true)
            }
          },
          () => {
            console.log("resolvifail")
            this.router.navigate(['login'])
            resolve(true)
          },
        )
      }
    })
  }
}
